export const stringToDate = (date, format, delimiter = '/') => {
  const formatLowerCase = format.toLowerCase()
  const formatItems = formatLowerCase.split(delimiter)
  const dateItems = date.split(delimiter)
  const monthIndex = formatItems.indexOf('mm')
  const dayIndex = formatItems.indexOf('dd')
  const yearIndex = formatItems.indexOf('yyyy')
  const month = parseInt(dateItems[monthIndex], 10) - 1
  return new Date(parseInt(dateItems[yearIndex], 10), month, parseInt(dateItems[dayIndex], 10))
}

export const dateToString = (date, format) => {
  // console.log('dateToString', date, typeof date)
  if (!date || date.leading === 0) {
    return ''
  }
  if (typeof date === 'string') {
    date = stringToDate(date, 'yyyy-MM-dd', '-')
  }
  const mm = date.getMonth() + 1; // getMonth() is zero-based
  const dd = date.getDate();
  const yyyy = date.getFullYear()
  const yy = `${yyyy}`.substring(2)
  const mmStr = mm > 9 ? `${mm}` : `0${mm}`
  const ddStr = dd > 9 ? `${dd}` : `0${dd}`
  let stringDate = format.toLowerCase().replace('mm', mmStr).replace('dd', ddStr)
  if (stringDate.indexOf('yyyy') >= 0) {
    stringDate = stringDate.replace('yyyy', `${yyyy}`)
  } else {
    stringDate = stringDate.replace('yy', `${yy}`)
  }
  return stringDate
}

export const getTime = (date) => {
  if (!date) {
    return ''
  }
  const hh = date.getHours()
  const mm = date.getMinutes()
  const hhStr = hh > 9 ? `${hh}` : `0${hh}`
  const mmStr = mm > 9 ? `${mm}` : `0${mm}`

  return `${hhStr}:${mmStr}`
}
